import palette from 'components/palette'
import * as React from 'react'
import { injectIntl, WrappedComponentProps } from 'react-intl'
import ReactTooltip from 'react-tooltip'
import styled, { css } from 'styled-components'
import { color, fontSize } from 'utils'

import selectTooltip, { TooltipNameType } from './selectTooltip'
import TooltipHost from './TooltipHost'

export { TooltipNameType } from './selectTooltip'

type TooltipPlacementType = 'right' | 'left' | 'top' | 'bottom'

type PropsType = {
  children: React.ReactElement<any>
  delayShow?: number
  hideOnTipHover?: boolean
  id?: string
  name: TooltipNameType
  placement?: TooltipPlacementType
  wrap?: boolean
} & WrappedComponentProps &
  Record<string, any>

const StyledTip = styled(ReactTooltip)<{ hideOnTipHover?: boolean }>`
  &.__react_component_tooltip {
    cursor: pointer;
    border-radius: 8px;
    font-weight: 500;
    text-align: left;
    padding: 0.375rem 0.75rem;
    text-transform: none;
    font-size: ${fontSize('xs')};
    max-width: 250px;
    box-shadow: 0 4px 8px ${color('dark900')};
    ${(p) =>
      !p.hideOnTipHover &&
      css`
        pointer-events: auto;
      `}
  }

  &.__react_component_tooltip.show {
    opacity: 1;
  }
`

const TooltipReact = ({
  children,
  delayShow,
  hideOnTipHover,
  id,
  intl,
  name,
  placement,
  wrap,
  ...rest
}: PropsType) => (
  <>
    <TooltipHost id={id ?? name} tip={name} wrap={wrap ?? true}>
      {children}
    </TooltipHost>
    <StyledTip
      backgroundColor={palette.dark600}
      borderColor={palette.dark900}
      delayHide={200}
      delayShow={delayShow || 750}
      effect='solid'
      hideOnTipHover={hideOnTipHover ?? false}
      id={id ?? name}
      place={placement ?? 'top'}
      textColor={palette.white}
    >
      {selectTooltip(name, intl, rest)}
    </StyledTip>
  </>
)

export default injectIntl(TooltipReact)
